import FloatingHelper, { FloatingHelperProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: FloatingHelperProps = {
  // @ts-ignore
  content: <FloatingHelper.Content title="title" body="body" />,
  target: <div>target</div>,
  placement: 'left',
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as FloatingHelperProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
